import { render, staticRenderFns } from "./ClientAdditionalColour.vue?vue&type=template&id=4892896e"
import script from "./ClientAdditionalColour.vue?vue&type=script&lang=js"
export * from "./ClientAdditionalColour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports